import { connect } from 'react-redux'
import { closeImageOverlay } from 'redux/actions/ui'
import GenericImageCarousel from '../organisms/generic-image-carousel'

const mapStateToProps = ({ ui }) => ({
  ui,
})

const mapDispatchToProps = {
  closeImageOverlay,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GenericImageCarousel)
